

const stateManager = require('../../utils/state/stateManager');
const stringUtil = require('../../utils/string/stringUtil');

module.exports.findSubCategory = function(subCategoryId)
{
    var accountsData = stateManager.getStore().getState().accountsData;
    let subCategory;
    if (accountsData != null && accountsData.categories != null)
    {
        for (let index = 0; index < accountsData.categories.length; index++)
        {
            if (subCategory != null)
                continue;
            const category = accountsData.categories[index];

            subCategory = category.subCategories.find(s => stringUtil.areStringSame(s.id, subCategoryId));
        }
    }
    return subCategory;
}

module.exports.getSubCategories = function(categoryId)
{
    var accountsData = stateManager.getStore().getState().accountsData;
    if (stringUtil.isStringNullOrEmpty(categoryId) || accountsData == null || accountsData.categories == null)
        return [];

    var category = accountsData.categories.find(c => stringUtil.areStringSame(c.id, categoryId));
    return category == null ? [] : category.subCategories;
}